import type { ParagraphTwoColsTextVideo as ParagraphTwoColsTextVideoData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import { VideoEmbed } from "../shared/VideoEmbed";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 6 — `PARAGRAPH_TWO_COLS_TEXT_VIDEO_LAYOUT`: tekst | YouTube.
 */
export function ParagraphTwoColsTextVideo({
  paragraph,
  t,
}: {
  paragraph: ParagraphTwoColsTextVideoData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      <div className={styles.colsTwo}>
        <HtmlText html={paragraph.text} />
        <VideoEmbed src={paragraph.video} title={paragraph.name} t={t} />
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
